export const withdrawalSteps = {
  withdrawalStepsAccount: "Cuenta",
  withdrawalStepsAmount: "Monto",
  withdrawalStepsWidthdraw: "Retirar",
  withdrawalStepsError: "Retiro fallido",
  withdrawalStepsErrorDesc_1: "Debes jugar al menos el 30% de lo depositado para poder retirar.",
  withdrawalStepsErrorDesc_2: "Su retiro ha fallado, verifique sus datos o contacte a soporte.",
  withdrawalStepsErrorDesc_3:
    "Su cuenta no se encuentra verificada. Se ha enviado un correo de verificación a su email.",
  withdrawalStepsErrorDesc_4: "El monto no está dentro de los rangos permitidos.",
  withdrawalStepsSuccess: "Retiro exitoso",
  withdrawalStepsSuccessMessage: "Su retiro ha sido procesado con éxito.",
  emailVerificationSentTitle: "Verificación de email",
  emailVerificationSentMessage:
    "Se ha enviado un correo de verificación a su email. Por favor, verifique su bandeja de entrada.",
  emailVerificationErrorTitle: "Error al enviar verificación",
  emailVerificationErrorMessage:
    "No se pudo enviar el correo de verificación. Por favor, intente nuevamente o contacte a soporte.",
  withdrawalStepsNext: "Siguiente",
  withdrawalStepsBack: "Volver",
  withdrawalStepsConfirm: "Confirmar",
  withdrawalStepsCancel: "Cancelar",

  // Content step 1,
  withdrawalStepsDailyWithdrawal: "Retiro Diario",
  withdrawalStepsWeeklyWithdrawal: "Retiro Semanal",
  withdrawalStepsWithdrawn: "Retirado",
  withdrawalStepsDailyRemaining: "Diario Restante",
  withdrawalStepsWeeklyRemaining: "Semanal Restante",
  withdrawalStepsSelectAccount: "Selecciona tu cuenta de pago móvil",
  withdrawalStepsSelectAccountDesc: "Por favor, para proceder con el retiro, seleccionar tu cuenta de pago móvil.",
  withdrawalStepsSelectAccountDesc2: "Si todavía no has configurado una cuenta de pago móvil haz clic ",
  withdrawalStepsSelectAccountlink: "aquí",
  withdrawalStepsSelectTitle: "Banco",
  withdrawalStepsSelectAccount_select: "Elige tu cuenta",

  // step 1 modal
  withdrawalStepsModalLimitReachedTitle: "Límite alcanzado",
  withdrawalDayModalLimitReachedMessage:
    "Has alcanzado el límite de retiro diario. Por favor, intenta de nuevo mañana.",
  withdrawalWeekModalLimitReachedMessage:
    "Has alcanzado el límite de retiro semanal. Por favor, intenta de nuevo la próxima semana",
  withdrawalStepsModalLimitReachedButton: "Aceptar",

  // Content step 2,
  withdrawalSteps_2_Amount: "Ingresa el monto a retirar",
  withdrawalSteps_2_AmountInput: "Ingresa el monto",
  widthdrawalSteps_2_Error: "Monto inválido",
  withdrawalSteps_2_AmountError: "Ingresa un monto inválido",
  widthdrawalSteps_2_Error2: "Balance insuficiente",
  widthdrawalSteps_2_Error3: "Monto Mínimo 200 Bs",
  widthdrawalSteps_2_Error4: "Monto Máximo 8.000 Bs Diarios",

  // Content step 3,
  withdrawalSteps_3_Confirm: "Confirmación de Retiro",
  withdrawalSteps_3_Bank: "Banco ",
  withdrawalSteps_3_PhoneNumber: "Teléfono",
  withdrawalSteps_3_Amount: "Monto",
  withdrawalSteps_3_YouWillWithdraw: "Vas a retirar",

  // Conditional form translations for withdrawals
  withdrawalExplanationTitle: "Registro Personal Requerido",
  withdrawalExplanationMessage:
    "Para completar el retiro, necesitas registrar tu información personal (nombre, apellido, cédula y teléfono). Esta información es necesaria para procesar tus retiros de forma segura.",
  registerAndWithdraw: "Registrar y Realizar Retiro",

  // BINANCE WITHDRAWAL
  binanceWithdrawalTitle: "Retiro vía Binance",
  binanceWithdrawalNetwork: "Red",
  binanceWithdrawalMinAmount: "Monto mínimo",
  binanceWithdrawalMaxAmount: "Monto máximo",
  binanceWithdrawalCommission: "Comisión",
  binanceWithdrawalAmountRequired: "El monto es requerido.",
  binanceWithdrawalAddress: "Dirección de wallet (TRC20)",
  binanceWithdrawalAddressModal: "Dirección de wallet",
  binanceWithdrawalAddressPlaceholder: "Ingresa la dirección de wallet (TRC20)",
  binanceWithdrawalAmount: "Monto a retirar",
  binanceWithdrawalAmountPlaceholder: "Ingresa el monto a retirar",
  binanceWithdrawalConfirmTitle: "Confirmar Retiro Binance",
  binanceWithdrawalInputErrorNumber: "Solo números y punto decimal permitidos.",
  binanceWithdrawalInputErrorInvalid: "El monto no es válido.",
  binanceWithdrawalInputErrorMin: "El monto mínimo es",
  binanceWithdrawalInputErrorMax: "El monto máximo es",
  binanceWithdrawalAddressErrorRequired: "La dirección es requerida.",
  binanceWithdrawalAddressErrorStart: "La dirección debe comenzar con 'T'.",
  binanceWithdrawalAddressErrorLength: "La dirección debe tener 34 caracteres.",
  binanceWithdrawalSuccessTitle: "Retiro exitoso",
  binanceWithdrwalAmountCorrect: "Monto correcto.",
  binanceWithdrawalAddressCorrect: "Dirección correcta.",
  binanceWithdrawalContinueBtn: "Continuar",
  binanceWithdrawalConfirmBtn: "Confirmar",

  // Withdrawal success/failure modal states
  withdrawalSuccessTitle: "¡Retiro Solicitado!",
  withdrawalSuccessMessage:
    "Tu solicitud de retiro ha sido procesada exitosamente. Recibirás el pago en tu cuenta de pago móvil en breve.",
  withdrawalSuccessClose: "Cerrar",
  withdrawalFailureTitle: "Retiro Fallido",
  withdrawalFailureMessage:
    "No pudimos procesar tu solicitud de retiro. Por favor, revisa los detalles e intenta nuevamente.",
  withdrawalFailureRetry: "Reintentar",
  withdrawalFailureClose: "Cerrar",
};
